import { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { Layout, Menu, Button, message } from "antd";
import { HomeOutlined, PlusOutlined } from "@ant-design/icons";
import mainStyles from "../../styles/Main.module.css";
import { getOrganizations } from "../../utils";
import Organization from "./Organization";
import AccountMenu from "../../fragments/AccountMenu/AccountMenu";
import CreateOrganizationModal from "./CreateOrganizationModal";

const { Header, Sider, Content } = Layout;

interface State {
  organizations: Organization[] | null;
  creating: boolean;
}

class Dashboard extends Component<any, State> {
  state: State = {
    organizations: null,
    creating: false,
  };

  componentDidMount() {
    this.fetchOrganizations();
  }

  fetchOrganizations = async () => {
    try {
      const organizations = await getOrganizations();
      this.setState({ organizations });
    } catch (e) {
      message.error((e as Error).message);
      this.setState({ organizations: [] });
    }
  };

  render() {
    return (
      <Layout className={mainStyles.main}>
        <Sider className={mainStyles.mainSider} width={200}>
          <div className={mainStyles.siderLogo}>Brixture</div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={["organizations"]}
            items={[
              {
                key: "organizations",
                icon: <HomeOutlined />,
                label: "Organizations",
              },
            ]}
          />
        </Sider>
        <Layout>
          <Header className={mainStyles.mainHeader}>
            <div className={mainStyles.headerTitle}>Select an organization</div>
            <div className={mainStyles.headerActions}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => this.setState({ creating: true })}
              >
                Create organization
              </Button>
              <AccountMenu />
            </div>
          </Header>
          <Content className={mainStyles.container}>
            {this.state.organizations?.map((c) => (
              <Organization key={c._id} organization={c} />
            ))}
          </Content>
        </Layout>
        <CreateOrganizationModal
          open={this.state.creating}
          onClose={(created) => {
            this.setState({ creating: false });
            if (created) {
              this.props.history.push(`/${created._id}`);
            }
          }}
        />
      </Layout>
    );
  }
}

export default withRouter(Dashboard);
